import React from 'react';
import ConfirmConsultModal from '../../Consult/ConfirmConsultModal';

const ConsultationDetail = () => {
    return (
        <div>
            <ConfirmConsultModal ></ConfirmConsultModal>
        </div>
    );
};

export default ConsultationDetail;

